import * as React from 'react';
export const GGSvg = React.forwardRef(function GGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M0 6.5h6.5V2h3v4.5H16v3H9.5V14h-3V9.5H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFD300',
      d: 'M4 7.5h3.5V4h1v3.5H12v1H8.5V12h-1V8.5H4z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EAEEF3',
      d: 'M14 2a2 2 0 0 1 2 2v2.5h-1V4a1 1 0 0 0-1-1H9.5V2zM2 2a2 2 0 0 0-2 2v2.5h1V4a1 1 0 0 1 1-1h4.5V2zm12 12a2 2 0 0 0 2-2V9.5h-1V12a1 1 0 0 1-1 1H9.5v1zM2 14a2 2 0 0 1-2-2V9.5h1V12a1 1 0 0 0 1 1h4.5v1z',
    }),
  );
});
GGSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var GG = {
  category: 'flag',
  colorable: false,
  name: 'GG',
  svg: GGSvg,
};
